import { postFetch, getFetch } from '@/utils/request'

export function collectionGoods(mallGoodsWarehouseId) {
    return getFetch('/collection/collectionGoods', {"mallGoodsWarehouseId":mallGoodsWarehouseId})
}

export function delCollectionGoods(mallGoodsWarehouseId) {
    return getFetch('/collection/delCollectionGoods', {"mallGoodsWarehouseId":mallGoodsWarehouseId})
}

export function getCollectionListData(pageNum, categoryId, searchKey, type) {
    return getFetch('/collection/getCollectionGoodsPage', {"pageNum":pageNum, "categoryId": categoryId, "searchKey":searchKey, type: type});
}

export function countCollectionData(categoryId, searchKey, type) {
    return getFetch('/collection/getCollectionCategoryCount', {"categoryId": categoryId, "searchKey":searchKey, type: type});
}

export function batchDelCollectionGoodsData(goodsIds) {
    return postFetch('/collection/batchDelCollectionGoods', null, {"ids":goodsIds})
}


// WEBPACK FOOTER //
// ./src/api/customer/collectionApi.js